import * as React from "react";
import * as StatusMessages from "../../../../constants/StatusMessages";
import { FormattedMessage } from "react-intl";
import StatusMessage from "../../../presentational/StatusMessage";
import LoginForm from "../../../forms/public/LoginForm/LoginForm";
const ExistingUser = (props) => (<div className="existing-user">
		<div className="vr vr_x4">
			<h2 className="hdg">
				<FormattedMessage id="login.loginHeader" defaultMessage="Login"/>
			</h2>
		</div>

		{props.children}

		<StatusMessage isError isActive={props.authError ? true : false} error={props.authError ? props.authError : null} customMessage={StatusMessages.AUTH.INTRO_LOGIN} domain="auth" willPersist/>
		<div className="vr vr_x4">
			<LoginForm login={props.login} fieldErrors={props.authFieldErrors} isLoading={props.authIsLoading}/>
		</div>
		<StatusMessage isLoad isActive={props.authIsLoading ? true : false}/>
		<div className="vr vr_x5">
			<div className="text">
				<p>
					<button type="button" className="link js-modal-btnTrigger" data-modaltriggerid="forgotPassword" onClick={() => props.openModal({ modalId: "forgotPassword", triggerId: "forgotPassword" })}>
						<FormattedMessage id="login.forgotPassword" defaultMessage="Forgot Password"/>
					</button>
				</p>
			</div>
		</div>
		<StatusMessage isError isActive={props.isForgotPasswordRateLimited} customMessage={StatusMessages.AUTH.FORGOT_PASSWORD_RATE_LIMITED}/>
	</div>);
export default ExistingUser;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/public/Login/ExistingUser.tsx